import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleMesageContainer = styled.div`
  background-color: ${(props: any) => props.theme.colors.primaryLight};
  border-radius: 5px;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  row-gap: 6px;
`
export const MessageTitle = styled.p`
  color: ${(props: any) => props.theme.colors.primary};
  font-size: 18px;
  letter-spacing: 0.25px;
  line-height: 16px;
`
export const MessageSubtitle = styled.p`
  color: ${(props: any) => props.theme.colors.text};
  letter-spacing: 0.25px;
  line-height: 16px;
  font-size: 12px;
`

export const CreateFormWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`
export const RulesWrapper = styled.div`
  flex: 1;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  padding: 12px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`
export const RulesTitle = styled.p`
  color: ${(props: any) => props.theme.colors.red500};
  font-size: 18px;
`

export const StyleLabel = styled.p`
  color: ${theme.colors.primary};
  font-size: 16px;
`

export const StyleGameSettingsWrapper = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  border-radius: 8px;
  background-color: ${(props: any) => props.theme.colors.white};
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  place-items: center;
  gap: 12px;
`

export const FeeAndWinningWrapper = styled.div`
  background-color: ${(props: any) => props.theme.colors.primaryLight};
  border-radius: 5px;
  padding: 16px 12px;
`

export const styledInput = `
  border:1px solid #343F52;
  background:#e6edf7;
`

export const GameWrapper = styled.div`
  display: flex;
  column-gap: 12px;
  align-items: center;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  background-color: ${(props: any) => props.theme.colors.white};
  padding: 6px 10px;
  border-radius: 14px;
`

export const GameNameContainer = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  padding: 5px;
  flex: 1;
  gap: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 300ms linear;
  &:hover {
    background-color: ${(props: any) => props.theme.colors.primaryLight};
  }
  background-color: ${({ selected, theme }: any) =>
    selected ? theme.colors.primaryLight : 'transparent'};
`

export const GameName = styled.p<{ selected?: boolean }>`
  color: ${({ selected, theme }: any) =>
    selected ? theme.colors.primary : theme.colors.text};
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
`
